import apiInstance from "../../apiInstance";
import widgetPreview from "../widgetPreview.js";

const yelpPreview = async (widget) => {
  const data = {
    error: "",
    fieldErrors: "",
    serveData: {},
    previewHtml: "",
  };


  const request_body = { widget };

  try {
    if (widget.isReloadRequired) {
      const response = await apiInstance.post("/widget/preview/", request_body);
      const resData = response.data.data;

      const dataNeeded = {
        name: widget.widgetTypeName,
        title: widget.title,
        htmlData: widget.htmlData,
        script: widget.widgetTypeScripts,
        content: resData.serveData,
        isReloadRequired: widget.isReloadRequired,
        widgetId: widget.id
      };

      await widgetPreview(dataNeeded);

    } else {
      const yelpContainer = document.querySelector(".yelp-all-reviews");
      updateYelpContainer(yelpContainer, widget);
    }
    return data;
  } catch (error) {
    console.error("Error in yelpPreview:", error);
    data.error = error;
    return data;
  }
};

const updateYelpContainer = (yelpContainer, widget) => {
  if (!yelpContainer) {
    console.error("No .yelp-all-reviews container provided");
    return;
  }

  const yelpData = widget.htmlData.yelp;
  const reviewFilter = yelpData.reviews.reviewFilter || "all";
  const wordCountThreshold = yelpData.button.wordCountThreshold;
  const maxReviews = parseInt(yelpData.fetchReviews);

  const yelpReviewsContainer = yelpContainer.closest(".yelp-reviews-container");


  const customDisplay = yelpData.header?.yelpCompanyName;
  if (yelpReviewsContainer) {
    const heading = yelpReviewsContainer.querySelector(".yelp-business-name");
    if (heading && customDisplay !== null && customDisplay !== undefined) {
      heading.innerHTML = customDisplay;
    }
  }

  // Filter reviews

  const reviews = yelpContainer.querySelectorAll(".yelp-single-review");
  let displayCount = 0;
  let totalReviews = 0;
  reviews.forEach((review) => {
    const rating = Number(review.getAttribute("data-rating")) || 0;
    const filterValue = reviewFilter === "all" ? -1 : Number(reviewFilter);
    const display = (filterValue === -1 || rating >= filterValue) && displayCount < maxReviews;
    if (display) {
      review.classList.remove("brtpmj-hidden");
      review.classList.add("filtered");
      totalReviews++;
      displayCount++;
    } else {
      review.classList.add("brtpmj-hidden");
      review.classList.remove("filtered");
    }
  });



  // Update review text and toggle buttons
  const toggleButtons = yelpContainer.querySelectorAll(".yelp-sr-toggle");
  const reviewTextContainers = yelpContainer.querySelectorAll(".yelp-sr-text");

  reviewTextContainers.forEach((textContainer) => {
    const truncatedDiv = textContainer.querySelector(".yelp-sr-text-truncated");
    const restDiv = textContainer.querySelector(".yelp-sr-text-rest");
    const ellipsis = textContainer.querySelector("span:not([class])");
    if (!truncatedDiv || !restDiv) return;

    const fullText = (truncatedDiv.textContent.trim() + " " + restDiv.textContent.trim()).trim();

    if (yelpData.button.readMoreStatus === "off") {
      // Show full text in restDiv if expanded
      truncatedDiv.style.display = "none";
      restDiv.style.display = "block";
      restDiv.textContent = fullText;
      if (ellipsis) {
        ellipsis.style.display = "none";
      }
    } else {
      const words = fullText.split(/\s+/).filter(Boolean);

      if (words.length > wordCountThreshold) {
        truncatedDiv.textContent = words.slice(0, wordCountThreshold).join(" ");
        restDiv.textContent = words.slice(wordCountThreshold).join(" ");
        if (ellipsis) {
          ellipsis.style.display = "inline";
        }
      } else {
        truncatedDiv.textContent = fullText;
        restDiv.textContent = "";
        if (ellipsis) {
          ellipsis.style.display = "none";
        }
      }

      truncatedDiv.style.display = "block";
      restDiv.style.display = "none";
    }
  });
  toggleButtons.forEach(button => {
    const reviewContent = button.closest(".yelp-sr-content");
    const textContainer = reviewContent.querySelector(".yelp-sr-text");
    const truncatedDiv = textContainer?.querySelector(".yelp-sr-text-truncated");
    const restDiv = textContainer?.querySelector(".yelp-sr-text-rest");
    const ellipsis = textContainer?.querySelector("span:not([class])");

    const fullText = (truncatedDiv.textContent.trim() + " " + restDiv.textContent.trim()).trim();
    const words = fullText.split(/\s+/).filter(Boolean);
    if (yelpData.button.readMoreStatus === "off" || words.length <= wordCountThreshold) {
      button.style.display = "none";
      if (ellipsis) {
        ellipsis.style.display = "none";
      }
    } else {
      const isExpanded = restDiv.style.display === "block";

      button.textContent = isExpanded ? "Read Less" : "Read More";
      button.style.display = "inline";
      if (ellipsis && words.length > wordCountThreshold) {
        ellipsis.style.display = "inline";
      }
    }
  });
  // Step 6: Apply CSS customizations
  const cssRoot = document.querySelector(":root");
  cssRoot.style.setProperty("--yelp-logo-display", yelpData.header.logoStatus === "off" ? "none" : "block");
  cssRoot.style.setProperty("--yelp-header-display", yelpData.header?.headerStatus === "off" ? "none" : "flex");
  cssRoot.style.setProperty("--yelp-name-display", yelpData.header.companyNameStatus === "off" ? "none" : "block");
  cssRoot.style.setProperty("--yelp-add-review-display", yelpData.header.addReviewStatus === "off" ? "none" : "block");
  cssRoot.style.setProperty("--yelp-review-count-display", yelpData.header.reviewCountStatus === "off" ? "none" : "inline-block");
  cssRoot.style.setProperty("--yelp-header-color", yelpData.header.headerColor || "#333333");
  cssRoot.style.setProperty("--yelp-header-font-size", yelpData.header.headerFontSize ? yelpData.header.headerFontSize + 'px' : "22px");
  cssRoot.style.setProperty("--yelp-header-bg-color", yelpData.header.headerBgColor || "#ffffff");
  cssRoot.style.setProperty("--yelp-header-fontfamily", yelpData.header.headerFontFamily);
  cssRoot.style.setProperty("--yelp-header-font-bold", yelpData.header.headerFontBold === "on" ? "bold" : "normal");
  cssRoot.style.setProperty("--yelp-header-font-italic", yelpData.header.headerFontItalic === "on" ? "italic" : "normal");
  cssRoot.style.setProperty("--yelp-header-review-count-bold", yelpData.header.reviewCountFontBold === "on" ? "bold" : "normal");
  cssRoot.style.setProperty("--yelp-header-review-count-color", yelpData.header.reviewCountColor || "#333333");
  cssRoot.style.setProperty("--yelp-review-count-font-family", `"${yelpData.header.reviewCountFontFamily || 'Helvetica Neue'}"`);
  cssRoot.style.setProperty("--yelp-review-cout-font-size", yelpData.header.reviewCountFontSize ? yelpData.header.reviewCountFontSize + 'px' : "22px");
  cssRoot.style.setProperty("--yelp-review-button-font-family", `"${yelpData.header.reviewButtonFontFamily || 'Helvetica Neue'}"`);
  cssRoot.style.setProperty("--yelp-review-button-text-color", yelpData.header.reviewButtonTextColor || "#ffffff");
  cssRoot.style.setProperty("--yelp-reviewButton-bg-color", yelpData.header.reviewButtonBgColor || "#d32323");
  cssRoot.style.setProperty("--yelp-reviewButton-font-size", yelpData.header.reviewButtonFontSize ? yelpData.header.reviewButtonFontSize + 'px' : "16px");
  cssRoot.style.setProperty("--yelp-reviewButton-hover-color", yelpData.header.reviewButtonHoverColor || "#ffffff");
  cssRoot.style.setProperty("--yelp-reviewButton-hover-bg-color", yelpData.header.reviewButtonHoverBgColor || "#aa1b1b");
  cssRoot.style.setProperty("--yelp-reviewButton-border-radius", yelpData.header.reviewButtonBorderRadius ? yelpData.header.reviewButtonBorderRadius + 'px' : "4px");
  cssRoot.style.setProperty("--yelp-read-more-display", yelpData.button.readMoreStatus === "off" ? "none" : "block");
  cssRoot.style.setProperty("--yelp-read-button-font-family", `"${yelpData.button.readButtonFontFamily || 'Helvetica Neue'}"`);
  cssRoot.style.setProperty("--yelp-read-button-text-color", yelpData.button.readButtonTextColor || "#007bff");
  cssRoot.style.setProperty("--yelp-read-button-font-size", yelpData.button.readButtonFontSize ? yelpData.button.readButtonFontSize + 'px' : "13px");
  cssRoot.style.setProperty("--yelp-read-button-hover-color", yelpData.button.readButtonHoverColor || "#aa1b1b");
  cssRoot.style.setProperty("--yelp-text-color", yelpData.reviews.reviewtextColor || "#333333");
  cssRoot.style.setProperty("--yelp-review-text-font-family", `"${yelpData.reviews.reviewtextFontFamily || 'Helvetica Neue'}"`);
  cssRoot.style.setProperty("--yelp-container-bg-color", yelpData.reviews.containerBgColor || "#ffffff");
  cssRoot.style.setProperty("--yelp-container-border-color", yelpData.reviews.containerBorderColor || "#e5e5e5");
  cssRoot.style.setProperty("--yelp-container-padding", yelpData.reviews.containerPadding ? yelpData.reviews.containerPadding + 'px' : "20px");
  cssRoot.style.setProperty("--yelp-card-text-font-family", `"${yelpData.cards.cardtextFontFamily || 'Helvetica Neue'}"`);
  cssRoot.style.setProperty("--yelp-card-bg-color", yelpData.cards.cardBgColor || "#ffffff");
  cssRoot.style.setProperty("--yelp-card-border-color", yelpData.cards.cardBorderColor || "#e5e5e5");
  cssRoot.style.setProperty("--yelp-card-text-color", yelpData.cards.cardTextColor || "#333333");
  cssRoot.style.setProperty("--yelp-text-font-size", yelpData.cards.cardtextFontSize ? yelpData.cards.cardtextFontSize + 'px' : "13px");
  cssRoot.style.setProperty("--yelp-card-shadow", yelpData.cards.cardShadow || "0 4px 12px rgba(0, 0, 0, 0.1)");
  cssRoot.style.setProperty("--yelp-card-border-radius", yelpData.cards.cardBorderRadius ? yelpData.cards.cardBorderRadius + 'px' : "8px");
  cssRoot.style.setProperty("--yelp-reaction-bar-display", yelpData.cards.reactionBarStatus === "off" ? "none" : "flex");
  cssRoot.style.setProperty("--yelp-review-photho-display", yelpData.cards.reviewPhothoStatus === "off" ? "none" : "flex");
  cssRoot.style.setProperty("--yelp-animation-speed", "0.3s");
  cssRoot.style.setProperty("--yelp-animation-enabled", "1");
  cssRoot.style.setProperty("--yelp-column-count", yelpData.reviews.reviewlayout === "masonry" ? "3" : "auto");
  cssRoot.style.setProperty("--yelp-sm-column-count", yelpData.reviews.reviewlayout === "masonry" ? "2" : "auto");
  cssRoot.style.setProperty("--yelp-xs-column-count", yelpData.reviews.reviewlayout === "masonry" ? "1" : "auto");
  cssRoot.style.setProperty("--yelp-word-threshold", yelpData.button?.wordCountThreshold);
  // Update layout class
  yelpContainer.classList.remove("layout-masonry", "layout-list", "carousel");
  yelpContainer.classList.add(
    yelpData.reviews.reviewlayout === "carousel" ? "carousel" : `layout-${yelpData.reviews.reviewlayout}`
  );

  // Carousel handling
  let carouselStyle = document.getElementById("mjwi-style-carousel");
  let carouselScript = document.getElementById("mjwi-script-carousel");

  if (yelpData.reviews.reviewlayout === "carousel" && totalReviews > 0) {
    if (!carouselStyle) {
      carouselStyle = document.createElement("link");
      carouselStyle.href = `${window.mjFrontend}/styles/yelpCarousel.css`;
      carouselStyle.id = "mjwi-style-carousel";
      carouselStyle.rel = "stylesheet";
      carouselStyle.type = "text/css";
      document.head.appendChild(carouselStyle);
    }

    const track = yelpContainer.querySelector(".yelp-carousel-track");
    if (!track) {
      const reviewsHtml = Array.from(yelpContainer.children)
        .filter((child) => child.classList.contains("yelp-single-review"))
        .map((child) => child.outerHTML)
        .join("");
      yelpContainer.innerHTML = `
        <div class="yelp-carousel-track">
          ${reviewsHtml}
        </div>
        <button class="yelp-carousel-next">❯</button>
        <button class="yelp-carousel-prev">❮</button>
    
      `;
    }

    if (!carouselScript) {
      carouselScript = document.createElement("script");
      carouselScript.src = `${window.mjFrontend}/scripts/yelpCarousel.js`;
      carouselScript.type = "text/javascript";
      carouselScript.id = "mjwi-script-carousel";
      carouselScript.onload = () => {
        window.initYelpCarousel?.();
      };
      document.head.appendChild(carouselScript);
    } else {
      window.initYelpCarousel?.();
    }
  } else {
    if (carouselStyle) {
      carouselStyle.remove();
    }
    if (carouselScript) {
      carouselScript.remove();
    }
    yelpContainer.classList.remove("carousel");
    const track = yelpContainer.querySelector(".yelp-carousel-track");
    if (track) {
      yelpContainer.innerHTML = track.innerHTML;
    }
    yelpContainer.style.transform = "translateX(0)";
  }
};

export default yelpPreview; 